import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errText(e) {
  return apiError(e?.response?.data?.detail) || e?.message || "Request failed";
}

export function imageUrl(fileIdOrUrl) {
  if (!fileIdOrUrl) return null;
  if (fileIdOrUrl.startsWith("http")) return fileIdOrUrl;
  if (fileIdOrUrl.startsWith("/api/")) return `${BACKEND_URL}${fileIdOrUrl}`;
  return `${API}/files/${fileIdOrUrl}`;
}

export const NO_PHOTO_IMAGE = "/no-photo.svg";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NjczNzk2NXww&ixlib=rb-4.1.0&q=85";

export const AGENT_IMAGE =
  "https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBoYW5kaW5nJTIwa2V5c3xlbnwwfHx8fDE3ODY3Mzc5NjV8MA&ixlib=rb-4.1.0&q=85";

export function propertyImage(prop, index = 0) {
  const imgs = prop?.images || [];
  if (imgs.length) return imageUrl(imgs[index % imgs.length]);
  return NO_PHOTO_IMAGE;
}

export function formatPrice(value, listingType) {
  const n = Number(value || 0);
  if (!n) return "Price on request";
  let out;
  if (n >= 10000000) out = `₹ ${(n / 10000000).toFixed(2)} Cr`;
  else if (n >= 100000) out = `₹ ${(n / 100000).toFixed(2)} Lac`;
  else out = `₹ ${n.toLocaleString("en-IN")}`;
  if (listingType === "rent" || listingType === "pg") out += "/mo";
  return out;
}
